// OP-5494 — REST client for the social-network catalog (read-only).
//
// Routed through the BFF passthrough at /api/v1/social-networks (OP-5492). The
// BFF wraps the OPHUB response in `ApiResponse<List<SocialNetworkDto>>` with a
// pagination block. The `plugins/api.ts` response interceptor unwraps that
// envelope for `unwrapEnvelope: true`: for paginated bodies it reshapes the response
// to `{ items, page, pageSize, totalCount, totalPages }`. We read `items`
// directly here.
import api from "@/plugins/api";
/**
 * Fetches the social-network catalog. The catalog is small (≤ 20 entries today),
 * so the FE only ever calls with the default pagination — `useSocialNetworkStore`
 * is the session-scoped cache layer above this.
 */
export async function fetchSocialNetworks(params) {
    const response = await api.get("/social-networks", {
        unwrapEnvelope: true,
        params: {
            active_only: params?.activeOnly ?? true,
            page: params?.page ?? 1,
            per_page: params?.perPage ?? 100,
        },
    });
    return response.data.items ?? [];
}
